import _classCallCheck from "/home/vsts/work/1/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import speedometer from './speedometer';

var Progress = /*#__PURE__*/function () {
  function Progress(length) {
    var emitDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

    _classCallCheck(this, Progress);

    this.length = parseInt(length, 10) || 0;
    this.transferred = 0;
    this.speed = 0;
    this.streamSpeed = speedometer(this.speed || 5000);
    this.initial = false;
    this.emitDelay = emitDelay;
    this.eventStart = 0;
    this.percentage = 0;
  }

  _createClass(Progress, [{
    key: "getRemainingBytes",
    value: function getRemainingBytes() {
      return parseInt(this.length, 10) - parseInt(this.transferred, 10);
    }
  }, {
    key: "getEta",
    value: function getEta() {
      return this.length >= this.transferred ? this.getRemainingBytes() / this.speed * 1000000000 : 0;
    }
  }, {
    key: "flow",
    value: function flow(chunk, onProgress) {
      var chunkLength = chunk.length;
      this.transferred += chunkLength;
      this.speed = this.streamSpeed(chunkLength);
      this.percentage = Math.round(this.transferred / this.length * 100);

      if (!this.initial) {
        this.eventStart = Date.now();
        this.initial = true;
      }

      if (this.length >= this.transferred || Date.now() - this.eventStart > this.emitDelay) {
        this.eventStart = Date.now();
        var progress = {
          total: this.length,
          transferred: this.transferred,
          speed: this.speed,
          eta: this.getEta()
        };

        if (this.length) {
          progress.remaining = this.getRemainingBytes();
          progress.percentage = this.percentage;
        }

        onProgress(progress);
      }
    }
  }]);

  return Progress;
}();

export { Progress as default };